
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useCarriers } from "@/hooks/useCarriers";

interface CarrierSelectProps {
  value: string;
  onValueChange: (value: string) => void;
}

export const CarrierSelect = ({ value, onValueChange }: CarrierSelectProps) => {
  const { carriers, isLoading } = useCarriers();

  // Sort carriers by order
  const sortedCarriers = [...(carriers || [])].sort((a, b) => {
    // Handle cases where order might be null
    if (a.order === null) return 1;
    if (b.order === null) return -1;
    return (a.order || 0) - (b.order || 0);
  });

  return (
    <div className="space-y-2">
      <Label htmlFor="insuranceCarrier">Insurance Carrier</Label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className="h-14">
          <SelectValue placeholder="Select insurance carrier" />
        </SelectTrigger>
        <SelectContent>
          {sortedCarriers.map((carrier) => (
            <SelectItem key={carrier.id} value={carrier.name}>
              {carrier.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
